import React, { createContext, useState, ReactNode } from "react";

interface CourseImageContextType {
  media: string | null;
  setMedia: (url: string) => void;
}

export const CourseImageContext = createContext<CourseImageContextType>({
  media: null,
  setMedia: () => {},
});

interface CourseImageProviderProps {
  children: ReactNode;
}

export const CourseImageProvider: React.FC<CourseImageProviderProps> = ({
  children,
}) => {
  const [media, setMedia] = useState<string | null>(null);

  return (
    <CourseImageContext.Provider value={{ media, setMedia }}>
      {children}
    </CourseImageContext.Provider>
  );
};
